var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',[_c('search-criteria',{on:{"submitSearch":_vm.startSearch}}),_vm._v(" "),_c('search-result',{key:_vm.keySearchResult,staticClass:"mt-2",attrs:{"searchResult":_vm.searchResultData}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-219e3854","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SearchTrainingRecords/Index.vue
// module id = null
// module chunks = 